import { useEffect } from "react";

export function useVersionCheck() {
  // useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch('/version.json', { cache: 'no-cache' });
        const data = await res.json();
        const currentVersion = localStorage.getItem('app_version');

        if (currentVersion && currentVersion !== data.version) {
          console.log('New version detected — refreshing...');
          localStorage.setItem('app_version', data.version);
          window.location.reload(true);
        } else {
          localStorage.setItem('app_version', data.version);
        }
      } catch (err) {
        console.error('Version check failed', err);
      }
    };

    const interval = setInterval(checkVersion, 30000); // every 30s
    checkVersion();

    return () => clearInterval(interval);
  // }, []);
}
